import React, { Component, ReactNode } from 'react';
import { ErrorFlexBoxColumn } from '../websiteGrader/Error';
import { ContainerForLoadingAndErrorComponents } from '../websiteGrader/ContainerForLoadingAndErrorComponents';

export interface HttpError extends Error {
  status: number;
  message: string;
  error?: any; // eslint-disable-line
}

interface Props {
  $aiTool?: boolean;
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: HttpError | null;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: HttpError): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    // Log the error to an error tracking service
    console.error({ error }, { errorInfo });
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <ContainerForLoadingAndErrorComponents $aiTool={this.props.$aiTool}>
          <ErrorFlexBoxColumn
            heading={this.state.error?.status === 500 ? 'Sorry, something went wrong' : this.state.error?.error}
            text={
              this.state.error?.message.includes('Not Found')
                ? 'We were unable to return your results, please try again later.'
                : this.state.error?.message
            }
          />
        </ContainerForLoadingAndErrorComponents>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
